import { useMutation } from '@tanstack/react-query';
import AddVersionMobileComponent from 'components/Content/ManageAccount/VersionMobile/AddVersionMobileComponent';
import { FormVersionMobileType } from 'components/Content/ManageAccount/VersionMobile/FormVersionMobileComponent';
import ModalStatus from 'materials/ModalStatus';
import { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { addHistoryVersionApp } from 'services/VersionMobileService';
import * as addAdmin from '../../../../core/action/ManageAccount/AdminBranch/ActionAddAdminBranch';
import * as formAdmin from '../../../../core/action/ManageAccount/AdminBranch/ActionFormDetailAdminBranch';
import * as GenerateAdminCode from '../../../../core/action/ManageAccount/AdminBranch/ActionGenerateAdminBranch';
import * as toggle from '../../../../core/action/toggle';
import React from 'react';

interface IProps {
  actionToggle: any;
  visible: any;
  jenisToggle: any;
  actionFormAdmin: any;

  GetAdminName: any;
  AccountType: any;
  GetAdminLastName: any;
  GetAdminEmail: any;
  GetAdminPhoneNumber: any;
  GetAdminDob: any;
  GetAdminAddress: any;
  GetAdminPhoto: any;

  addAdmin: any;
  generateAdminCode: any;

  isLoading: any;
  refetch: any;
  Code: any;
  username:string
}

const AddVersionMobileContainer = (props: IProps) => {
  const defaultValue = {
    nameVersi: '',
    pic: props.username,
    email: '',
    catatan: '',
    status: true,
  };
  const [dataFormAdmin, setDataFormAdmin] =
    useState<FormVersionMobileType>(defaultValue);
  const { mutate: submitAdminBranch, isLoading } = useMutation(
    addHistoryVersionApp,
    {
      onSuccess: res => {
        if (res.status === 200) {
          props.refetch();
          handleClear();
          ModalStatus({
            status: 'success',
            title: 'Data berhasil disimpan',
          });
        } else {
          ModalStatus({
            status: 'error',
            title: 'Terjadi Kesalahan!!!',
            content:  'Silahkan Hubungi Admin',
          });
        }
      },
      onError: () => {
        ModalStatus({
          status: 'error',
          title: 'Internal Server Error',
          content: 'Silahkan Hubungi Admin',
        });
      },
    }
  );

  const handleChange = (name: string, value: any) => {
    setDataFormAdmin(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleClear = () => {
    props.actionToggle.changeModal();
    props.actionToggle.clearJenisToggle();
    props.actionFormAdmin.changeClearDataAdminForm();
    setDataFormAdmin(defaultValue);
  };
  const handleSaveAdminBranch = () => {
    const data = {
      version: dataFormAdmin.nameVersi,
      status: dataFormAdmin.status,
      catatan: dataFormAdmin.catatan,
    };
    submitAdminBranch(data);
  };
  return (
    <AddVersionMobileComponent
      visible={
        props.jenisToggle === 'AddVersionMobile' && props.visible === true
          ? true
          : false
      }
      jenisToggle={props.jenisToggle}
      handleChange={handleChange}
      isLoading={isLoading}
      handleClear={handleClear}
      handleSubmit={handleSaveAdminBranch}
      initialData={dataFormAdmin}
    />
  );
};

const mapStateToProps = (state: any) => ({
  visible: state.Toggle.modal,
  jenisToggle: state.Toggle.jenisToggle,
  GetAdminName: state.AdminBranch.FormAdmin.AdminName,
  AccountType: state.AdminBranch.FormAdmin.AccountType,
  GetAdminLastName: state.AdminBranch.FormAdmin.AdminLastName,
  GetAdminEmail: state.AdminBranch.FormAdmin.AdminEmail,
  GetAdminPhoneNumber: state.AdminBranch.FormAdmin.AdminPhoneNumber,
  GetAdminDob: state.AdminBranch.FormAdmin.AdminDob,
  GetAdminAddress: state.AdminBranch.FormAdmin.AdminAddress,
  GetAdminPhoto: state.AdminBranch.FormAdmin.AdminPhoto,
  Code: state.AdminBranch.FormAdmin.Code,
  isLoading: state.Toggle.isLoading,
  username: state.Auth.UsernameAuth,
});

const mapDispatchToProps = (dispatch: any) => ({
  actionToggle: bindActionCreators(toggle, dispatch),
  actionFormAdmin: bindActionCreators(formAdmin, dispatch),
  addAdmin: bindActionCreators(addAdmin, dispatch),
  generateAdminCode: bindActionCreators(GenerateAdminCode, dispatch),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(AddVersionMobileContainer);
